import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Space, Text, Title } from '../../atoms';
import { theme } from '../../theme';

import * as S from './styles';

type Props = { status: 'initial' | 'complete' | 'error' };

export const UploadStatusColumn: React.FC<Props> = ({ status }) => {
  switch (status) {
    case 'complete':
      return (
        <S.StatusColumnWrapper>
          <Space direction="vertical" align="center" size={0}>
            <CheckCircleIcon htmlColor={theme.colors.green40} />
            <Space direction="vertical" align="center" size={4}>
              <Title level={3}>Complete</Title>
              <Text $size={12} $color={theme.colors.grey50}>
                <S.TextLink $weight={600}>Change photo</S.TextLink>
              </Text>
            </Space>
          </Space>
        </S.StatusColumnWrapper>
      );

    case 'error':
      return (
        <S.StatusColumnWrapper>
          <Space direction="vertical" align="center" size={0}>
            <CancelIcon htmlColor={theme.colors.red50} />
            <Space direction="vertical" align="center" size={4}>
              <Title level={3}>Failed</Title>
              <S.TextLink $weight={600}>Try again</S.TextLink>
            </Space>
          </Space>
        </S.StatusColumnWrapper>
      );
  }

  return (
    <S.StatusColumnWrapper>
      <Space direction="vertical" align="center">
        <S.Icon src="/images/add-photo.svg" alt="Add photo" />
        <Space direction="vertical" align="center" size={4}>
          <Title level={3}>Drag & drop</Title>
          <Text $size={12} $color={theme.colors.grey50}>
            your file here, or <S.TextLink $weight={600}>browse</S.TextLink>
          </Text>
        </Space>
      </Space>
    </S.StatusColumnWrapper>
  );
};
